import React,{useState,useEffect} from 'react';
import axios from "axios";
import {Row,Col,Card,Spin,Divider,Layout,Popconfirm, Button,message} from "antd";
import { CheckCircleOutlined, CloseCircleOutlined,ReadOutlined } from "@ant-design/icons";
import { useSelector,useDispatch } from "react-redux";
import AdminSideBar from './AdminSideBar';
import { getUploadedDocuments } from '../../features/UploadedDocumentsSlice';

const { Content} = Layout;

function LiveRequests() {
    const [Loading, setLoading] = useState(false);
    const { user: currentUser } = useSelector((state) => state.auth);
    const kycs = useSelector((state) => state.uploadedDocuments);

    const id = currentUser.Id;
    const clientAPIkey = currentUser.ClientApikey;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUploadedDocuments())
      }, [dispatch]);

      function confirmReviewed(){
        console.log('document confirmed');
      }
    function approveKYC(id,file){
      setLoading(true);
      let headersList = {
      "accept": "*/*",
      "Content-Type": "application/json" 
      }
  
      let reqOptions = {
        url: `${process.env.REACT_APP_BASE_URL}approveKYC/${id}/${file}`,
        method: "GET",
        headers: headersList
      }
      axios.request(reqOptions).then(function (response) {
        setLoading(false);
        message.success("successfully created a new account you can now lock in")
      }).catch((error) => {
       message.error(error.response.data);
      setLoading(false);
      })
    }
  return (  
    <Content style={{marginTop:'5%'}}>  
    <Layout hasSider >
     <AdminSideBar props='2' />
    <Layout className="site-layout">
      <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}> 
    <Row gutter={[24, 0]}>
      <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
        <Card
          bordered={false}
          className="criclebox cardbody h-full">
        <div className="ant-list-box table-responsive">
           <Divider/>
          <table className="width-100">
            <thead>
              <tr>
                <th>Client Name</th>
                <th>Document</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              { kycs.status==='loading'||Loading?<Spin size='large'  tip="Loading..." style={{margin:'30% 100%'}}/>:
              kycs.list?.filter(function (file) {
                return file.Verified === 0;
                 })?.map((information) => (
                <tr key={information.Filename}>
                  <td>
                    <h6>
                      {information.Filename}
                    </h6>
                  </td>
                  <td>
                    <h6>{information.Description}</h6></td>
                  <td>
                  <h6><a href={`${process.env.REACT_APP_BASE_URL}client/view-file?id=${id}&filesrc=${information.Filename}`} target='_blank'>
                      <Button icon={<ReadOutlined />} style={{backgroundColor:'#00b33c',color:'white',borderRadius:5}} >View</Button>
                      </a>
                  </h6>
                  </td>
                  <td>
                  <h6>
                    {Loading?<Button style={{backgroundColor:'#00b33c',color:'white',borderRadius:5}} disabled>Loading...</Button>:
                    <Button icon={<CheckCircleOutlined />} onClick={()=>approveKYC(id,information.Filename)} style={{backgroundColor:'#00b33c',color:'white',borderRadius:5}}>Approve</Button>}
                  </h6>
                  </td>
                    <td>
                      <Popconfirm
                            title=" Decline this document?"
                            onConfirm={()=>confirmReviewed(id,information.Filename,clientAPIkey)}
                            okText="Yes"
                            cancelText="No">
                        <Button icon={<CloseCircleOutlined />} style={{borderRadius:5}} type='primary' danger>Decline</Button>        
                      </Popconfirm>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </Card>
      </Col>
    </Row> 
      </Content>
    </Layout>
  </Layout>
  </Content>
  )
}

export default LiveRequests